<template>
  <div>
    <div v-if="success" class="text-center pt-6" >
      <slot />
    </div>
    <div v-else class="pt-6" >
      <div v-if="hasError" >
        <p
          v-for="error in errors"
          :key="error"
          class="text-error font-bold text-sm"
        >{{ error }}</p>
      </div>
      <p class="text-sm hidden">* You must complete all fields.</p>
      <form class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4" >
        <div>
          <label for="first-name" class="sr-only">First Name</label>
          <div class="input-wrapper group rounded overflow-hidden border" :class="{ 'border-error': hasError && formData.fname == '' }">
            <input
              v-model="formData.fname"
              id="first-name"
              type="text"
              class="text-input pl-4"
              placeholder="First Name"
              required
            >
          </div>
        </div>
        <div>
          <label for="last-name" class="sr-only">Last Name</label>
          <div class="input-wrapper group rounded overflow-hidden border" :class="{ 'border-error': hasError && formData.lname == '' }">
            <input
              v-model="formData.lname"
              id="last-name"
              type="text"
              class="text-input pl-4"
              placeholder="Last Name"
              required
            >
          </div>
        </div>

        <div>
          <label for="email-address" class="sr-only">Email Address</label>
          <div class="input-wrapper group rounded overflow-hidden border" :class="{ 'border-error': hasError && formData.email == '' }">
            <input
              v-model="formData.email"
              id="email-address"
              type="email"
              class="text-input"
              placeholder="Email Address"
              required
            >
          </div>
        </div>

        <div>
          <label for="phone-number" class="sr-only">Phone Number</label>
          <div class="input-wrapper group rounded overflow-hidden border" :class="{ 'border-error': hasError && formData.phone == '' }">
            <input
              v-model="formData.phone"
              id="phone-number"
              type="tel"
              class="text-input"
              placeholder="Phone Number"
              required
            >
          </div>
        </div>

        <div class="md:col-span-2 lg:col-span-4" >
          <label for="message" class="sr-only">Message</label>
          <div class="input-wrapper group h-auto rounded overflow-hidden border" :class="{ 'border-error': hasError && formData.message == '' }">
            <textarea
              type="text"
              id="message"
              v-model="formData.message"
              class="textarea-input py-4"
              placeholder="Type your message here."
              required
            />
          </div>
        </div>

        <div class="md:col-span-2 h-0 w-0 overflow-hidden" >
          <label for="terms" class="opacity-0 absolute z-0 -left-[9999]" >
            <input type="checkbox" v-model="formData.terms" id="terms" name="terms" tabindex="-1" />
            I agree to the <a href="/privacy-policy/" target="_blank" tabindex="-1" >Terms & Conditions</a>
          </label>
        </div>

        <div class="md:col-span-2 lg:col-span-4 flex flex-col justify-center items-center pt-4" >
          <button
            @click.prevent="submitForm"
            type="submit"
            :disabled="processing"
            class="cta-button mt-0"
          >
            Send Inquiry
          </button>
          <div
            v-if="!processing"
            class="text-sm p-4 leading-none text-white"
            :class="{ 'text-error font-bold': this.hasError }" >
            All fields required</div>
          <div
            v-if="processing"
            class="text-sm p-4 leading-none text-white"
            >Sending&nbsp;inquiry.</div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PropertyInquiryForm',

  props: {
    nonce: {
      type: String,
      default: '',
    },
    listing: {
      type: Object,
      default: () => {}
    },
    userIp: {
      type: String,
      default: '',
    },
    userAgent: {
      type: String,
      default: '',
    },
    referrer: {
      type: String,
      default: '',
    }
  },

  data () {
    return {
      processing: false,
      errors: {},
      success: false,
      hasError: false,
      formData: {
        fname: '',
        lname: '',
        phone: '',
        email: '',
        message: '',
        mls_number: '',
        photo: '',
        address: '',
        price: '',
        terms: false,
        js_on: ''
      },
      mailto: '',
      submitted: false,
    }
  },

  computed: {
    validate() {
      return this.formData.fname != '' &&
        this.formData.lname != '' &&
        this.formData.phone != '' &&
        this.formData.email != '' &&
        this.formData.message != ''
    },
  },

  mounted () {
    this.formData.mls_number = this.listing.mls_account
    this.formData.address = this.listing.full_address
    this.formData.price = this.listing.price
    this.formData.photo = this.listing.media_objects.data[0].url
    this.formData.post_id = this.postId
    this.formData.user_ip = this.userIp
    this.formData.user_agent = this.userAgent
    this.formData.referrer = this.referrer
  },

  methods: {
    submitForm () {
      this.processing = true
      let date = new Date()
      this.formData.js_on = date.getFullYear()

      fetch('/wp-json/kma/v1/submit-property-inquiry', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': this.nonce
        },
        body: JSON.stringify(this.formData)
      })
        .then(r => r.json())
        .then((res) => {
          if(res.success){
            this.success = true
            dataLayer.push({
              'event': 'inquiry_form_submitted',
              'conversionValue': this.listing.price,
              'address' : this.listing.full_address,
              'mls_number' : this.listing.mls_account
            });
          } else {
            this.success  = false
            this.hasError = true
            this.errors   = res.data
          }

          this.processing   = false
        })
    },

  }
}
</script>
